var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-select",
        {
          ref: "select",
          staticClass: "search_input",
          attrs: {
            label: "title",
            placeholder: "Выберите ЕГК код",
            filterable: false,
            appendToBody: true,
            options: _vm.codes,
          },
          on: { input: _vm.selectCode, search: _vm.searchCode },
          nativeOn: {
            keypress: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              $event.preventDefault()
            },
          },
          scopedSlots: _vm._u([
            {
              key: "option",
              fn: function (option) {
                return [
                  _c("div", { staticClass: "d-center text-wrap" }, [
                    _vm._v(
                      "\n        (" +
                        _vm._s(option.id) +
                        ") " +
                        _vm._s(option.title) +
                        " "
                    ),
                    option.invalid
                      ? _c("span", { staticClass: "color_red" }, [
                          _vm._v("не активный"),
                        ])
                      : _vm._e(),
                  ]),
                ]
              },
            },
            {
              key: "selected-option",
              fn: function (option) {
                return [
                  _c("div", { staticClass: "text-wrap" }, [
                    _vm._v(
                      "\n        (" +
                        _vm._s(option.id) +
                        ") " +
                        _vm._s(option.title) +
                        " "
                    ),
                    option.invalid
                      ? _c("span", { staticClass: "color_red" }, [
                          _vm._v("не активный"),
                        ])
                      : _vm._e(),
                  ]),
                ]
              },
            },
          ]),
          model: {
            value: _vm.code,
            callback: function ($$v) {
              _vm.code = $$v
            },
            expression: "code",
          },
        },
        [
          _c("template", { slot: "no-options" }, [
            _vm._v("\n      введите название препарата..\n    "),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      !_vm.hideDetails
        ? _c(
            "div",
            { staticClass: "mt-1" },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._l(_vm.details, function (c, index) {
                return !c.id.to_delete
                  ? _c("div", { staticClass: "code_block" }, [
                      _c("div", { staticClass: "input-group" }, [
                        _c(
                          "div",
                          { staticClass: "input-group-prepend egk_div" },
                          [
                            _c(
                              "span",
                              { staticClass: "input-group-text egk_title" },
                              [_vm._v(_vm._s(c.title.value))]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          staticClass: "form-control not_valid_code mw-85",
                          attrs: { type: "text", disabled: "" },
                          domProps: { value: c.invalid ? "не активен" : null },
                        }),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: c.id.value,
                              expression: "c.id.value",
                            },
                          ],
                          staticClass: "form-control mw-85",
                          attrs: { type: "text", disabled: "" },
                          domProps: { value: c.id.value },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(c.id, "value", $event.target.value)
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "input-group-append" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-outline-danger",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.removeCode(+c.id.value)
                                },
                              },
                            },
                            [_c("i", { staticClass: "icon-fa icon-fa-trash" })]
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "mt-1" },
                        [
                          _vm.loadingRates[index]
                            ? _c("clip-loader", {
                                staticClass: "text-center",
                                attrs: {
                                  loading: true,
                                  color: _vm.$constants.LOADING_COLOR,
                                  size: "20px",
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.loadingRates[index] && _vm.codeRates[c.id.value]
                            ? [
                                _c("div", { staticClass: "input-group" }, [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.codeRates[c.id.value].rate_1,
                                        expression:
                                          "codeRates[c.id.value].rate_1",
                                      },
                                    ],
                                    staticClass: "form-control small_field",
                                    attrs: {
                                      type: "number",
                                      placeholder: "k-1",
                                    },
                                    domProps: {
                                      value: _vm.codeRates[c.id.value].rate_1,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.codeRates[c.id.value],
                                          "rate_1",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "pl-2 pr-2 m-auto" },
                                    [_vm._v("/")]
                                  ),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.codeRates[c.id.value].rate_2,
                                        expression:
                                          "codeRates[c.id.value].rate_2",
                                      },
                                    ],
                                    staticClass: "form-control small_field",
                                    attrs: {
                                      type: "number",
                                      placeholder: "k-2",
                                    },
                                    domProps: {
                                      value: _vm.codeRates[c.id.value].rate_2,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.codeRates[c.id.value],
                                          "rate_2",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value:
                                          _vm.codeRates[c.id.value].comment,
                                        expression:
                                          "codeRates[c.id.value].comment",
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      placeholder: "комментарий",
                                    },
                                    domProps: {
                                      value: _vm.codeRates[c.id.value].comment,
                                    },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.$set(
                                          _vm.codeRates[c.id.value],
                                          "comment",
                                          $event.target.value
                                        )
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "input-group-append" },
                                    [
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-outline-success",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.updateEgkRate(
                                                +c.id.value
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "icon-fa icon-fa-save",
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]),
                              ]
                            : _vm._e(),
                        ],
                        2
                      ),
                    ])
                  : _vm._e()
              }),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert alert-info" }, [
      _c("p", { staticClass: "mb-0" }, [
        _vm._v(
          "Спеццена: 1/2 значит 100 сайт : 200 справ, а 2/1 значит 100 сайт : 50 справ"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }